// extracted by mini-css-extract-plugin
export default {"group":"Group_group__EUFJz","title":"Group_title__j7PIE"};